import { ApiGetRequest, ApiPostRequest } from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Pindah Stock Container',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/conf',
      },
      {
        text: 'Pindah Stock Container',
        href: '/adm/conf/pindah-stock',
        active: true,
      },
    ],
    showmodal: false,
    export: 0,
    detail: false,
    fields: [
      {
        key: 'doc_no',
        label: 'B/L No',
      },
      {
        key: 'ex_vessel',
        label: 'Ex Vessel',
      },
      {
        key: 'voy',
        label: 'Voy',
      },
      {
        key: 'container',
        label: 'Container',
      },
      {
        key: 'size',
        label: 'Size',
      },
      {
        key: 'type',
        label: 'Type',
      },
      {
        key: 'from_company_principle',
        label: 'From Principle',
      },
      {
        key: 'to_company_principle',
        label: 'To Principle',
      },
    ],
    form: {
      from_principle: '',
      from_code_principle: '',
      from_company_principle: '',
      to_principle: '',
      to_code_principle: '',
      to_company_principle: '',
      prefix: '',
      number: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changePindahStock(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getListPindahStock({ commit, state }) {
    commit('changePindahStock', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`conf/pindah-stock`, params);
    commit('changePindahStock', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async submitUpdate({ commit, state, dispatch }) {
    commit('changePindahStock', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`conf/pindah-stock`, data.form);

    commit('changePindahStock', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },
};
